import { useLocalStorage } from 'react-use'

export interface UserGuide {
	DRAFT_RECOVER_TOOLTIP: boolean
}
export default function useUserGuide(key: keyof UserGuide) {
	const [value, set, remove] = useLocalStorage<UserGuide[typeof key]>(key)

	return [
		value,
		() => {
			set(true)
		},
		remove,
	] as const
}
